export const SET_PROPERTY = 'property/SET_PROPERTY';
export const SET_PROPERTY_IS_READY = 'property/SET_PROPERTY_IS_READY';
